import { useState } from "react";
import { cancelBonus } from "../../../data/wallet";
import { showErrorToast, showSuccessToast } from "../../../actions/helper";
import { Button, Col, Modal, Spin } from "antd";
import PromotionOneWalletModal from "../../../pages/PromotionOneWalletModal";

function SignUpBonusConfirmModal({visible, handleClose, callbacks}) {
    return (
        <Modal
        visible={visible} onCancel={handleClose} footer={null} width={440} centered>
        <div
            style={{
                width: "100%",
                padding: "16px",
            }}
        >
            <div
                style={{
                    paddingTop: "30px",
                    width: "100%",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                    }}
                >
                    <h2>Xác nhận hủy khuyến mãi</h2>
                </div>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "16px",
                    }}
                >
                    Khuyến mãi này chỉ có thể được đăng ký một lần.
                    <br/>
                    Nếu hủy, bạn sẽ không thể đăng ký lại.
                </p>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                    width: "100%",
                    gap: "16px",
                }}
            >
                <Button
                    style={{
                        border: "1px solid #00A6FF",
                        backgroundColor: "#FFFFFF",
                        color: "#00A6FF",
                        width:  "172px",
                        height: "45px"
                    }}
                    onClick={() => {
                        callbacks.handleClose();
                    }}
                >
                    Quay lại
                </Button>
                <Button
                    style={{
                        backgroundColor: "#00A6FF",
                        color: "#FFFFFF",
                        width:  "172px",
                        height: "45px"
                    }}
                    onClick={async () => {
                        callbacks.handleConfirm();
                        callbacks.handleClose();
                    }}
                >
                    Xác nhận
                </Button>
            </div>
        </div>
        </Modal>
    );
}

export default SignUpBonusConfirmModal